import { getAuth } from "firebase/auth";

/**
 * Wait for authentication to be ready
 */
const waitForAuth = () => {
  return new Promise((resolve, reject) => {
    const auth = getAuth();

    // If user is already authenticated, resolve immediately
    if (auth.currentUser) {
      resolve(auth.currentUser);
      return;
    }

    // Wait for auth state to change
    const unsubscribe = auth.onAuthStateChanged((user) => {
      unsubscribe();
      if (user) {
        resolve(user);
      } else {
        reject(new Error("User not authenticated"));
      }
    });

    // Timeout after 10 seconds
    setTimeout(() => {
      unsubscribe();
      reject(new Error("Authentication timeout"));
    }, 10000);
  });
};

/**
 * Get the current user's ID token for API authentication
 * @returns {Promise<string>} The user's ID token
 */
export const getUserIdToken = async () => {
  try {
    const user = await waitForAuth();
    const token = await user.getIdToken();
    return token;
  } catch (error) {
    throw new Error("Failed to get user ID token: " + error.message);
  }
};
